import { render, staticRenderFns } from "./simple-select.renderer.vue?vue&type=template&id=3ec93528&"
import script from "./simple-select.renderer.vue?vue&type=script&lang=js&"
export * from "./simple-select.renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports